/* fc-reviews.js (2026-10-12 speed pass): the review carousel (dots, arrows, keys, autoplay, pause when off-screen).
   Moved out of sections/fc-reviews.liquid so browsers cache it across pages; the
   root is #fc-rv and per-instance values travel as data attributes. The
   body is the former inline script, unchanged apart from those lookups.
   Re-initialises on shopify:section:load for the theme editor. */
(function () {
  'use strict';
  function initSection(root) {

  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rv-slide]'));
  var dots   = Array.prototype.slice.call(root.querySelectorAll('[data-rv-dot]'));
  var prev   = root.querySelector('[data-rv-prev]');
  var next   = root.querySelector('[data-rv-next]');
  if (slides.length < 2) return;

  var AUTO_MS  = parseInt(root.getAttribute('data-fc-auto-ms'), 10) || 7000;
  var current  = 0;
  var timer    = null;
  var paused   = false;
  var inView   = true;

  function go(idx) {
    current = ((idx % slides.length) + slides.length) % slides.length;
    slides.forEach(function(s, i){ s.classList.toggle('is-active', i === current); });
    dots.forEach(function(d, i){
      d.classList.toggle('is-active', i === current);
      d.setAttribute('aria-selected', i === current ? 'true' : 'false');
    });
  }

  function tick() {
    if (paused || !inView) return;
    go(current + 1);
  }
  function start() { stop(); timer = setInterval(tick, AUTO_MS); }
  function stop()  { if (timer) { clearInterval(timer); timer = null; } }

  if (prev) prev.addEventListener('click', function(){ go(current - 1); start(); });
  if (next) next.addEventListener('click', function(){ go(current + 1); start(); });
  dots.forEach(function(d){
    d.addEventListener('click', function(){
      var i = parseInt(d.getAttribute('data-rv-dot'), 10) || 0;
      go(i);
      start();
    });
  });

  // Pause on hover/focus/touch
  root.addEventListener('mouseenter', function(){ paused = true; });
  root.addEventListener('mouseleave', function(){ paused = false; });
  root.addEventListener('focusin',    function(){ paused = true; });
  root.addEventListener('focusout',   function(){ paused = false; });
  root.addEventListener('touchstart', function(){ paused = true; }, { passive: true });
  root.addEventListener('touchend',   function(){ setTimeout(function(){ paused = false; }, 1500); }, { passive: true });

  // Arrow-key navigation when section is focused/visible
  document.addEventListener('keydown', function(e){
    if (!inView || document.activeElement && !root.contains(document.activeElement)) return;
    if (e.key === 'ArrowLeft')  { go(current - 1); start(); }
    if (e.key === 'ArrowRight') { go(current + 1); start(); }
  });

  // Pause when scrolled out of view — saves work + starts the next
  // tick aligned with the moment the section returns to screen
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ inView = en.isIntersecting; });
    }, { threshold: 0.2 });
    io.observe(root);
  }

  start();

  }
  function init() {
    var root = document.getElementById('fc-rv');
    if (!root || root.getAttribute('data-fc-init') === '1') return;
    root.setAttribute('data-fc-init', '1');
    initSection(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#fc-rv')) init();
  });
})();
